<template lang="html">

<b-container fluid>

<b-row>
  <b-col md="6" offset-md="6" d-flex h-100 flex-wrap>

  <a href="#" class="btn" v-b-tooltip title="Log out" v-on:click.prevent="logOut">
    <font-awesome-layers class="fa-fw fa-3x">
     <font-awesome-icon icon="circle" class="blade-blue"/>
     <font-awesome-icon icon="sign-out-alt" style="color:#fff"  transform="shrink-5.0"/>
</font-awesome-layers>
  </a>
  </b-col>
</b-row>
    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >

          <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
                <b-card title=""  sub-title="" style=" margin-top:3%">
                          <div class="loader"> <stretch v-if="busy" ></stretch> </div>
          <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">
               {{errorMsg}}
          </b-alert>

            </b-card>
        </b-col>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
 </b-container>
</template>

<script lang="js">

import { Stretch } from 'vue-loading-spinner'
import LicenseFooter from './LicenseFooter'

export default {
  name: 'no-seats-available',
  components: {
    Stretch,
    LicenseFooter
  },
  props: [],
  mounted: async function () {
    try {
      let self = this
      self.busy = false
      self.hasError = true
      self.errorMsg = 'All of the available seats for your organization are currently in use'
    } catch (error) {
      self.busy = false
      self.hasError = true
      self.errorMsg = 'All of the available seats for your organization are currently in use'
    }
  },
  data () {
    return {

      selectedInstance: 'Select a region',
      errorMsg: '',
      hasError: false,
      busy: false,
      instanceOptions: { }
    }
  },
  methods: {

    logOut: async function () {
      let self = this
      await self.$auth.logOut()
      self.$router.push('/')
    }
  },
  computed: {

  }
}
</script>

<style src="../assets/styles.css"></style>



// WEBPACK FOOTER //
// src/components/NoSeatsAvailable.vue